import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AlertComponent} from '../alert/alert.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.commonService.getNameUser();
    // this.getNameUser();

  }

  getNameUser() {
    console.log('user : ');
    console.log('ud : ',  this.commonService.getUserName());
    // return this.commonService.getNameUser();
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/header/header.component.ts